import { Routes } from '@angular/router';

import { authGuard } from '@core/guards/auth.guard';

export const MATERIAL_HANDLING_ROUTES: Routes = [
  {
    path: 'material-handling-dashboard',
    title: 'Material Handling Dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./material-handling-dashboard/material-handling-dashboard').then(
        (m) => m.MaterialHandlingDashboard,
      ),
  },
  {
    path: 'material-handling-pricing-configuration',
    title: 'Material Handling Pricing Configuration',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./material-handling-pricing-configuration/material-handling-pricing-configuration').then(
        (m) => m.MaterialHandlingPricingConfiguration,
      ),
  },
];
